<script setup>
    // From https://raw.githubusercontent.com/codeat3/blade-forkawesome/main/resources/svg/gitlab.svg

    defineProps({
        class: {
            type: String,
            default: "h-5 w-5",
        },
    })
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1792 1792"
        fill="currentColor"
        :class="class"
    >
        <path
            d="M104 706l792 1015-868-630c-24-18-34-49-25-77l101-308zm462 0h660L896 1721zM368 94l198 612H104L302 94c11-31 55-31 66 0zm1320 612l101 308c9 28-1 59-25 77l-868 630 792-1015zm0 0h-462l198-612c11-31 55-31 66 0z"
        />
    </svg>
</template>
